import { RouteItem } from '@eastcoal/router/types/route'

import { ASSIGN_MANAGER_ACTION } from '../components/AssignManger/uuid'

import {
  MEMBER_AUTHENTICATION_PAGE,
  MEMBER_UNASSIGNED_TAB,
  ASSIGN_FOLLOWER_ACTION
} from './uuid'

export const memberAuthenticationRoute: RouteItem = {
  title: '认证审核',
  hideChildrenInMenu: true,
  children: [
    {
      title: '认证列表',
      path: '/member/authentication/list',
      uuid: MEMBER_AUTHENTICATION_PAGE,
      Component: () => import('./index'),
      children: [
        {
          title: '查看待分配页签',
          uuid: MEMBER_UNASSIGNED_TAB
        },
        {
          title: '分配跟进人员',
          uuid: ASSIGN_FOLLOWER_ACTION
        },
        {
          title: '分配客户经理',
          uuid: ASSIGN_MANAGER_ACTION
        }
      ]
    }
  ]
}
